import { axiosBase, axiosDevelopment } from './config';

export const BlockService = {
    POST_BLOCKS_UPDATE_NAME(data) {
        return axiosBase.post(`f2020_update_blocks`, data);
    },
    POST_BLOCKS_REORDER(data) {
        return axiosBase.post(`f2020_order_blocks`, data);
    },
    POST_DELETE_BLOCK(data) {
        return axiosBase.post(`f2020_delete_block`, data);
    },
    POST_BLOCK(data) {
        return axiosDevelopment.post(`ajax/block-snapshot`, data);
    },
    GET_BLOCK_THUMBNAILS(userID, sessionID, template) {
        return axiosDevelopment.get(`ajax/get-blocks-new-api?u=${userID}&sn=${sessionID}&t=${template}`);
    },
    GET_BLOCK_DATA(templateID, userID, sessionID) {
        return axiosDevelopment.get(`ajax/get-blocks/${templateID}?u=${userID}&sn=${sessionID}`);
    },
};